<template>
  <v-container
    id="data-tables"
    tag="section"
  >
    <base-material-card
      color="indigo"
      icon="mdi-devices"
      inline

      class="px-5 py-3"
    >
    <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Portals List
        </div>
      </template>
      <filter-component @handleSearchChild="handleSearch" />
      <v-data-table
        :headers="headers"
        :items="portals"
        :server-items-length="pagination.total"
        :loading="loading"
        :expanded.sync="expanded"
        single-expand
        show-expand
        hide-default-footer
      >
        <template v-slot:item.status="{item}">
          <v-icon
            :color="item.status =='online'? 'success': 'red'"
          >
            {{ item.status == 'online' ? 'mdi-account-check': 'mdi-account-off' }}
          </v-icon>
          <span
            :class="[item.status == 'online' ?'success--text':'red--text']"
            icon="mdi-eye"
          >{{ item.status }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                v-if="item.type == 'device'"
                v-bind="attrs"
                class="px-2 ml-1"
                color="success"
                min-width="0"
                small
                @click="portalConfig(item)"
                v-on="on"
              >
                <v-icon x-small>
                  mdi-cog-outline
                </v-icon>
              </v-btn>
            </template>
            <span>Configuration</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                v-if="item.type == 'device'"
                v-bind="attrs"
                class="px-2 ml-1"
                color="indigo"
                min-width="0"
                small
                @click="callRestart(item)"
                v-on="on"
              >
                <v-icon x-small>
                  mdi-restart
                </v-icon>
              </v-btn>
            </template>
            <span>Restart</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                v-if="item.type == 'device'"
                v-bind="attrs"
                class="px-2 ml-1"
                color="warning"
                min-width="0"
                small
                @click="getDeviceInfo(item)"
                v-on="on"
              >
                <v-icon x-small>
                  mdi-wifi
                </v-icon>
              </v-btn>
            </template>
            <span>Network Info</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                v-bind="attrs"
                class="px-2 ml-1"
                color="error"
                min-width="0"
                small
                @click="callRemove(item)"
                v-on="on"
              >
                <v-icon x-small>
                  mdi-close
                </v-icon>
              </v-btn>
            </template>
            <span>Remove</span>
          </v-tooltip>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-container class="py-0">
              <v-row>
                <v-col
                  cols="12"
                  md="3"
                >
                  <b>Venue:</b>
                  {{ item.venue_name }}
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                >
                  <b>Country:</b>
                  {{ item.venue_country }}
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                >
                  <b>Telephone:</b>
                  {{ item.venue_telephone }}
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                >
                  <b>Wallet</b>
                  Amount: {{ item.venue_wallet_amount }}
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="3"
                >
                  <b>Address:</b>
                  {{ item.venue_address }}
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                >
                  <b>Admin Email:</b>
                  {{ item.admin_email }}
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                >
                  <b>Portal Host:</b>
                  {{ item.admin_api_host }}
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                >
                  <b>Portal Password:</b>
                  {{ item.admin_api_password }}
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="3"
                >
                  <b>Last Activity At:</b>
                  {{ item.portal_last_active }}
                </v-col>
              </v-row>
            </v-container>
          </td>
        </template>
      </v-data-table>
      <div class="text-center pt-2">
        <v-pagination
          v-model="pagination.current"
          :length="pagination.totalPages"
          total-visible="7"
          dark
          color="grey"
          @input="handlePageChange"
        />
      </div>
    </base-material-card>

    <v-dialog
      v-model="configDialog"
      max-width="500"
    >
      <v-card>
        <v-card-title>
          Portal Configurations
          <v-spacer />
          <v-icon
            aria-label="Close"
            @click="configDialog = false"
          >
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text>
          <v-row
            align="center"
            justify="center"
          >
            <v-switch
              v-model="activePortal.config.name"
              color="indigo darken-3"
              label="Ask customer name"
              input-value="true"
            />
            <v-spacer />
            <v-switch
              v-model="activePortal.config.destination"
              color="indigo darken-3"
              label="Ask destination"
              input-value="true"
            />
          </v-row>
          <v-row
            align="center"
            justify="center"
          >
            <v-radio-group
              v-model="activePortal.config.request_as"
              row
              label="Accept name as"
            >
              <v-radio
                color="indigo darken-3"
                label="Notes"
                value="notes"
              />
              <v-radio
                color="indigo darken-3"
                label="Name"
                value="name"
              />
            </v-radio-group>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="configDialog = false"
          >
            cancel
          </v-btn>
          <v-btn
            color="success"
            text
            @click="callUpdateConfig()"
          >
            update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="networkDialog"
      max-width="500"
    >
      <v-card>
        <v-card-title>
          Portal Network Details
          <v-spacer />
          <v-icon
            aria-label="Close"
            @click="networkDialog = false"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text>
          <v-row
            v-for="(p, index) in activePortal.network_details"
            :key="p + index"
            align="center"
            justify="center"
          >
            <p>{{ index }} : {{ p }}</p>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="
              networkDialog = false;
              currentDevice = null;
            "
          >
            cancel
          </v-btn>
          <pages-btn
            small
            color="success"
            :loading="resetLoader"
            :disabled="resetLoader"
            @click="fetchLatestNetworkDetails()"
          >
            fetch latest
            <template v-slot:loader>
              <span class="custom-loader">
                <v-icon light>mdi-cached</v-icon>
              </span>
            </template>
          </pages-btn>

          <!-- <v-btn color="success" text @click="fetchLatestNetworkDetails()">
            fetch latest
          </v-btn>-->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import moment from 'moment'
  import Vue from 'vue'
  import { status } from '@/services/User'
  import {
    search,
    updateConfig,
    restartPortal,
    removePortal,
    networkDetails,
    getPortal,
  } from '@/services/portals.js'
  import filterComponent from './filter'
  // Vue.filter('moment-ago', function (date) {
  //   return moment(date).fromNow()
  // });
  // Vue.filter('status', function (item) {
  //   if(item.status == 'online') {
  //     var val = moment(item.portal_last_active).add('minutes',30)
  //     return moment.duration(moment().diff(val)).asHours()>2 ? 'recently online': 'online';
  //   }
  //   else {
  //     return 'offline';
  //   }
  //   // return moment.duration(val).asMinutes()>30 ? 'offline': 'recently online'
  // });
  export default {
    name: 'PortalsList',
    components: {
      filterComponent,
      PagesBtn: () => import('./.././../../../pages/components/Btn'),
    },

    data () {
      return {
        loading: true,
        portals: [],
        expanded: [],
        headers: [
          { text: 'Details', value: 'data-table-expand' },
          { text: 'ID', align: 'center', sortable: false, value: 'id' },
          {
            text: 'Username',
            align: 'center',
            sortable: false,
            value: 'username',
          },
          {
            text: 'Password',
            align: 'center',
            sortable: false,
            value: 'password',
          },
          {
            text: 'Device',
            align: 'center',
            sortable: false,
            value: 'device_id',
          },
          {
            text: 'Portal Type',
            align: 'center',
            value: 'type',
            sortable: false,
          },
          { text: 'Role', align: 'center', value: 'role', sortable: false },
          { text: 'Status', align: 'center', value: 'status', sortable: false },
          {
            text: 'Bookings Count',
            align: 'center',
            value: 'booking_count.total',
            sortable: false,
          },
          {
            text: 'Last Active at',
            align: 'center',
            value: 'portal_last_active',
            sortable: false,
          },
          { text: 'Actions', align: 'center', value: 'actions', sortable: false },
        ],
        pagination: {
          current: 1,
          total: 0,
          totalPages: 0,
        },
        configDialog: false,
        activePortal: {
          config: {
            name: false,
            destination: false,
            request_as: 'name',
          },
          network_details: null,
          updated_at: null,
        },
        filterParams: {},
        networkDialog: false,
        currentDevice: null,
        resetLoader: false,
      }
    },
    mounted () {
      const params = {
        device_id: '',
        venues: [],
        portal_type: '',
        portal_role: '',
        page: 1,
      }
      this.handleSearch(params)
    },

    methods: {
      setModel (idx, model) {
        this.$set(
          this.portals,
          idx,
          model
        )
      },
      portalJoined (user) {
        const idx = this.portals.findIndex(p => p.user_id === user.id)
        let model = this.portals.find(p => p.user_id === user.id)
        if (model) {
          model.status = 'online'
          this.setModel(idx, model)
        }
      },
      portalLeft (user) {
        const idx = this.portals.findIndex(p => p.user_id === user.id)
        let model = this.portals.find(p => p.user_id === user.id)
        if (model) {
          model.status = 'offline'
          this.setModel(idx, model)
        }
      },
      listen () {
        window.Echo.join('taxipoint')
          .here((users) => {
            console.log('here')
            const onlineUsers = users.filter((u) => u.id !== this.$store.state.user.id && u.status === 'offline')
            const onlineIds = onlineUsers.map((o) => {
              let model = this.portals.find(p => p.user_id === o.id)
              let idx = this.portals.findIndex(p => p.user_id === o.id)
              if (model) {
                model.status = 'online'
                this.setModel(idx, model)
              }
            })
          })
          .joining((user) => {
            console.log('join')
            status(user.id, { status: 'online' }) // calling api
            this.portalJoined(user)
          })
          .leaving((user) => {
            console.log('leave')
            status(user.id, { status: 'offline' })
            this.portalLeft(user)
          })
      },
      handleSearch (params) {
        this.filterParams = params
        this.loading = true
        var queryString = Object.keys(params)
          .map((key) => key + '=' + params[key])
          .join('&')
        search(queryString).then((response) => {
          this.loading = false
          this.portals = response.data.obj.data.map(this.getDisplayPortal)
          this.pagination.total = response.data.obj.total
          this.pagination.totalPages = response.data.obj.last_page
          this.listen()
        })
      },

      handlePageChange (value) {
        this.pagination.current = value
        this.filterParams.page = value
        this.handleSearch(this.filterParams)
      },

      getDisplayPortal (portal) {
        return {
          id: portal.id,
          device_id: portal.device_id ? portal.device_id : '---',
          venue_name: portal.venue.name,
          venue_country: portal.venue.country,
          venue_city: portal.venue.city,
          venue_wallet_amount: portal.venue.wallet_amount,
          venue_address: portal.venue.street,
          venue_telephone: portal.venue.telephone,
          admin_email: portal.venue.admin.email,
          admin_api_host: portal.venue.admin.api_host,
          portal_last_active: portal.user.last_active,
          admin_api_password: portal.venue.admin.api_password,
          type: portal.type,
          role: portal.role ? portal.role : '---',
          booking_count: portal.booking_count,
          status: portal.user.status,
          config: portal.config,
          updated_at: portal.updated_at,
          network_details: portal.network_details,
          username: portal.user.email,
          password: portal.device_id ? '---' : portal.user.api_password,
          user_id: portal.user_id,
        }
      },

      portalConfig (val) {
        this.configDialog = true
        this.activePortal = val
      },
      callUpdateConfig () {
        updateConfig(this.activePortal).then((res) => {
          console.log('update config called')
          this.configDialog = false
        })
      },

      callRestart (val) {
        restartPortal(val.id)
      },

      callRemove (val) {
        removePortal(val.id).then((res) => {
          this.localRemoveObj(val)
        })
      },

      localRemoveObj (val) {
        const portals = this.portals
        const idx = portals.findIndex((p) => p.id === val.id)
        portals.splice(idx, 1)
        this.portals = portals
      },

      getDeviceInfo (val) {
        this.networkDialog = true
        this.activePortal = val
        this.currentDevice = val.device_id
      },

      fetchLatestNetworkDetails () {
        this.resetLoader = true
        networkDetails(this.currentDevice).then((res) => {
          setTimeout(() => {
            getPortal(this.currentDevice)
              .then((data) => {
                this.resetLoader = false
                const oldTime = new Date(this.activePortal.updated_at)
                const newTime = new Date(data.data.obj.updated_at)
                if (oldTime >= newTime) {
                  status(data.data.obj.user_id, { status: 'offline' })
                  this.activePortal.status == 'online' ? this.activePortal.status == 'offline' : ''
                  alert('device is not reachable')
                } else {
                  this.activePortal.network_details =
                    data.data.obj.network_details
                  this.activePortal.updated_at = data.data.obj.updated_at
                }
              })
              .then(() => (this.resetLoader = false))
          }, 5000)
        })
      },
    },
  }
</script>
